import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { IncomesAndExpenses } from '@financial/domain';
import { IncomesAndExpensesService } from './incomes-and-expenses.service';
import { YearMonth } from '@financial/arch';
import * as moment from 'moment';

@Component({
  selector: 'app-incomes-and-expenses',
  templateUrl: './incomes-and-expenses.component.html',
  styleUrls: ['./incomes-and-expenses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncomesAndExpensesComponent implements OnInit, OnChanges {
  @Input() selectedDate: Date = new Date();

  incomesAndExpenses: IncomesAndExpenses[] = [];

  chartData: any[] = [];

  colorScheme = {
    domain: ['#f44336', '#4db6ac']
  };

  view: [number, number] = [null, 330];

  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  showYAxisLabel = false;
  legendPosition = 'below';

  constructor(
    private incomesAndExpensesService: IncomesAndExpensesService,
    private changeDetection: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.fetchData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDate && !changes.selectedDate.firstChange) {
      this.fetchData();
    }
  }

  private fetchData() {
    const yearMonth = YearMonth.fromMoment(moment(this.selectedDate));

    this.incomesAndExpensesService.findBy(yearMonth).subscribe(
      (result) => {
        const isAllZero = result.income === 0 && result.expense === 0;

        if (result && !isAllZero) {
          this.incomesAndExpenses = [result];

          this.chartData = [
            {
              name: moment(this.selectedDate).format('MM/YYYY'),
              series: [
                { name: 'Pagar', value: result.expense },
                { name: 'Receber', value: result.income }
              ]
            }
          ];
        } else {
          this.incomesAndExpenses = [];
          this.chartData = [];
        }

        this.changeDetection.markForCheck();
      },
      (error) => console.log(error)
    );
  }

  yAxisTickFormatting(val: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0
    }).format(val);
  }
}
